/* @flow */

const HereMapsLanguages = {
  'ara': 'Arabic',
  'baq': 'Basque',
  'cat': 'Catalan',
  'chi': 'Chinese (simplified)',
  'cht': 'Chinese (traditional)',
  'cze': 'Czech',
  'dan': 'Danish',
  'dut': 'Dutch',
  'eng': 'English',
  'fin': 'Finnish',
  'fre': 'French',
  'ger': 'German',
  'gle': 'Gaelic',
  'gre': 'Greek',
  'heb': 'Hebrew',
  'hin': 'Hindi',
  'ind': 'Indonesian',
  'ita': 'Italian',
  'nor': 'Norwegian',
  'per': 'Persian',
  'pol': 'Polish',
  'por': 'Portuguese',
  'rus': 'Russian',
  'sin': 'Sinhalese',
  'spa': 'Spanish',
  'swe': 'Swedish',
  'tha': 'Thai',
  'tur': 'Turkish',
  'ukr': 'Ukrainian',
  'urd': 'Urdu',
  'vie': 'Vietnamese',
  'wel': 'Welsh'
};

export default HereMapsLanguages;
